import React from "react";
import { GetStaticPaths, GetStaticProps } from "next";
import { Request } from "@xt/xtbase";
import store from "store";
import { getOrigin } from "utils/method";
import { get_symbol } from "api/server/market";
import { get_tdk } from "api/server/tdk";
import CfdLayout from "../index";
import CfdTrade from "@/components/Pages/Cfd/trade";

const DEFAULT_CFD_SYMBOL = "btc_aed_cfd";

interface Props {
  tdk?: any;
  locale?: string;
  symbol: string;
  pageUrl: string;
}

const ContractTradePage: React.FC<Props> = ({ symbol, pageUrl, locale, tdk }) => {
  console.log("%c【Page Contract Trade render】", "color:#00aecc", { symbol, pageUrl, locale, tdk });
  // 确保symbol带_cfd后缀
  const cfdSymbol = symbol.endsWith("_cfd") ? symbol : `${symbol}_cfd`;
  store.market.updateStateOnce({ name: cfdSymbol });

  return (
    <CfdLayout>
      <CfdTrade />
    </CfdLayout>
  );
};

export default ContractTradePage;

export const getStaticPaths: GetStaticPaths = async () => {
  console.log("getStaticPaths Contract Trade");
  const paths: {
    params: {
      symbol: string;
    };
  }[] = [];

  // TODO: 后续从后端获取差价合约列表；兜底默认用法币对
  paths.push({ params: { symbol: DEFAULT_CFD_SYMBOL } });

  console.log(paths);

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  console.log("getStaticProps Contract Trade");

  const symbol = params && typeof params.symbol === "string" ? params.symbol : "";
  // Next.js i18n 配置中 defaultLocale 是 "default"
  const targetLocale = locale || "default";
  if (!symbol) {
    console.log("symbol undefined start redirect");
    return {
      redirect: {
        destination: `/${targetLocale}/futures/contract/${DEFAULT_CFD_SYMBOL}`,
        permanent: false,
      },
    };
  }

  // 验证 CFD symbol 是否存在
  const globalAny = global as any;
  !globalAny.xtCfdSymbols && (globalAny.xtCfdSymbols = { symbols: [] });
  console.log(symbol + " global.xtCfdSymbols.version", globalAny.xtCfdSymbols.version);
  const symbolRet = await Request.XtAxios.asyncAwait(get_symbol, {
    params: {
      version: globalAny.xtCfdSymbols.version,
      types: "cfd",
    },
    headers: { "Accept-Encoding": "identity" },
  });
  console.log("server get_symbol CFD over", symbolRet.err ? "error" : "success", !symbolRet.err ? symbolRet.data?.version : "");
  if (!symbolRet.err && symbolRet.data) {
    if (symbolRet.data.version !== globalAny.xtCfdSymbols.version) {
      globalAny.xtCfdSymbols = symbolRet.data;
      console.log(symbol + " global.xtCfdSymbols.version-new", globalAny.xtCfdSymbols.version);
    }
  }
  // 获取不到该 symbol 配置也不默认跳转，直接渲染页面
  const pageUrl = `/futures/contract/${symbol}`;
  const props: Props = {
    symbol,
    locale: targetLocale,
    pageUrl,
  };

  //tdk
  const tdkUrl = getOrigin("www") + "/" + targetLocale + pageUrl;
  console.log("start req tdk", tdkUrl);
  const tdkRet = await Request.XtAxios.asyncAwait(get_tdk, {
    params: {
      url: tdkUrl,
    },
  });
  console.log("TDK=======", tdkRet.err ? "error" : "success", tdkUrl);
  if (!tdkRet.err && tdkRet.data) {
    props.tdk = tdkRet.data;
    console.log(tdkRet.data);
  }

  return {
    props,
    revalidate: 60,
  };
};
